import { colors } from '../../../theme/colors'

export const ChartTooltipConstants = {
  defaultEnabled: true,
  viewportPadPx: 8,
  cursorOffsetPx: 8,
  barMarkerWidthPx: 21,
  barMarkerHeightPx: 12,
  barMarkerRadiusPx: 2,
  hoverGuideStroke: colors.presets.neutral['0'],
  hoverGuideStrokeOpacity: 0.35,
  panel: {
    bg: colors.presets.turquoise['100'],
    borderRadius: 0,
    px: '16px',
    py: '8px',
    w: 'max-content',
    maxW: '280px',
    boxShadow: 'none',
    zIndex: 10000,
  },
}

export const ChartTooltipStyles = {
  panel: ChartTooltipConstants.panel,
}
